import { ChangeDetectorRef,Component, ElementRef, Input, OnInit, QueryList, ViewChildren, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { ComponentBase, T4DataSource } from 't4core';
import { RequestDetails, ServiceRequestStatus } from 't4core';
import { T4_FindIssueDialog } from '../../dialogs/findIssueDialog/findIssueDialog';
import { T4_ServiceDialog } from '../../dialogs/serviceDialog/serviceDialog';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import * as moment from 'moment';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { T4DatatableWidget } from '../../../../t4common';

@Component({
    selector: 'ClaimCasesOverview',
    templateUrl: './Claims.html',
    styleUrls: ['./Claims.css']
})
export class ClaimCasesOverview extends ComponentBase implements OnInit {
    @Input() public isOneWay: boolean = false;

    @ViewChild("newClaims") newClaims: T4DatatableWidget;
    @ViewChild("decisionClaims") decisionClaims: T4DatatableWidget;
    @ViewChild("sparePartsClaims") sparePartsClaims: T4DatatableWidget;
    @ViewChild("serviceClaims") serviceClaims: T4DatatableWidget;
    @ViewChild("openClaims") openClaims: T4DatatableWidget;
    @ViewChild("closedClaims") closedClaims: T4DatatableWidget;

    @ViewChildren(MatSort) ctrlSorters: QueryList<MatSort>;
    @ViewChildren(MatPaginator) ctrlPagers: QueryList<MatPaginator>;

    private sorters: MatSort[] = [];
    private pagers: MatPaginator[] = [];

    public txtFilter: FormControl = new FormControl();

    public filterText: string = "";

    public openClaimRequests: RequestDetails[] = [];
    public closedClaimRequests: RequestDetails[] = [];

    public filteredNewClaims: RequestDetails[];
    public filteredWaitingForDecisionClaims: RequestDetails[];
    public filteredWaitingForSparePartsClaims: RequestDetails[];
    public filteredWaitingForServiceClaims: RequestDetails[];
    public filteredOpenClaims: RequestDetails[];
    public filteredClosedClaims: RequestDetails[];

    public owners: string[];
    groupsControl = new FormControl([]);

    tblAllColumns = ['userId', 'ClaimId', 'CreatedAt', 'RentalObject', 'RentalLocation', 'Description'];
    tblFeaturedColumns = ['userId', 'ClaimId', 'EstimatedDate', 'Status', 'RentalObject', 'RentalLocation', 'ServiceLocation'];
    tblNewColumns = ['userId', 'ClaimId', 'CreatedAt', 'RentalObject', 'RentalLocation', 'Description'];
    tblActiveColumns = ['userId', 'ClaimId', 'EstimatedDate', 'Status', 'RentalObject', 'RentalLocation', 'ServiceLocation'];
    tblExpiredColumns = ['userId', 'ClaimId', 'RentalObject', 'RentalLocation', 'ServiceLocation'];
    tblMissingColumns = ['userId', 'ClaimId', 'RentalObject', 'CreatedAt', 'RentalLocation'];

    constructor(private router: Router, private route: ActivatedRoute, el: ElementRef, private changeDetectorRef: ChangeDetectorRef) {
        super();

        //this.txtFilter.valueChanges.pipe(debounceTime(150))
        //    .subscribe(() => {
        //        if (this.featuredRequests) this.featuredRequests.filter = this.txtFilter.value;
        //        if (this.newRequests) this.newRequests.filter = this.txtFilter.value;
        //        if (this.activeRequests) this.activeRequests.filter = this.txtFilter.value;
        //        if (this.expiredRequests) this.expiredRequests.filter = this.txtFilter.value;
        //        if (this.missingRequests) this.missingRequests.filter = this.txtFilter.value;
        //    });
    }

    async ngOnInit() {

        await this.populateDatasources();
        await this.createFilterOptions();

      var transform = {
        ObjectLocation: (x) => x.ObjectLocation.Name,
        ServiceLocation: x => x.ServiceLocation?.Name,
        RentalObject: x => x.RentalObject?.Title,
      };

      this.allTables().forEach(t => t.exportTransformations = transform);
    }

    private allTables(): T4DatatableWidget[] {
        return [this.newClaims, this.decisionClaims, this.sparePartsClaims, this.serviceClaims, this.openClaims, this.closedClaims].filter(t => !!t);
    }

    private async populateDatasources() {
        var token = this.UI.beginLoading('Turbo.OneWayAdmin.Claims.msgLoadingRequest', 'Loading claims', null);
        this.openClaimRequests = await this.Api.get<any[]>("Service/GetActiveClaimRequests") ?? [];
        this.closedClaimRequests = await this.Api.get<any[]>("Service/GetCompletedClaimRequests") ?? [];
        this.UI.loaderCompleted(token);
    }

    public async createFilterOptions() {
      this.owners = await this.Api.get<string[]>("RentalObjectService/GetSelectOwners")
      this.applyFilter();
    }

    applyFilter() {
        var token = this.UI.beginLoading('Turbo.OneWayAdmin.Claims.msgLoadingRequest', 'Loading claims', null);
        const selectedOwners = this.groupsControl.value;// Get the selected values from the FormControl
        const open = this.filterData(selectedOwners, this.openClaimRequests);
        this.filteredNewClaims = open.filter(x => x.Status == ServiceRequestStatus.New);
        this.filteredWaitingForDecisionClaims = open.filter(x => x.Status == ServiceRequestStatus.WaitingForDecision);
        this.filteredWaitingForSparePartsClaims = open.filter(x => x.Status == ServiceRequestStatus.SparePartOrdered);
        this.filteredWaitingForServiceClaims = open.filter(x => x.Status == ServiceRequestStatus.ServiceOrdered);
        this.filteredOpenClaims = open;
        this.filteredClosedClaims = this.filterData(selectedOwners, this.closedClaimRequests);
        this.changeDetectorRef.detectChanges();
        this.UI.loaderCompleted(token);
    }

    filterData(selectedOwners: string[], claimCases: RequestDetails[]): RequestDetails[] {
      if (selectedOwners.length === 0) return claimCases;
      return claimCases.filter(item => selectedOwners.some(o => o === item.Owner));
    }
    // Data
    //private requests: RequestDetails[] = [];
    //private Completedrequests: RequestDetails[] = [];

    // ViewModel
    //public damagedRequests: T4DataSource;
    //public completedRequests: T4DataSource;

    //public allRequests: T4DataSource;
    //public newRequests: T4DataSource;
    //public featuredRequests: T4DataSource;
    //public activeRequests: T4DataSource;
    //public expiredRequests: T4DataSource;
    //public missingRequests: T4DataSource;

    // Event handlers
    public FindIssue() {
      this.Dialog.open(T4_FindIssueDialog).afterClosed().toPromise().then((x: RequestDetails) => {
            if (x) {
                this.Dialog.open(T4_ServiceDialog, { data: { requestId: x.Id } }).afterClosed().toPromise().then((x: any) => { });
            }
        });
    }
    // Data functions
    //private async loadRequests() {
    //    var token = this.UI.beginLoading('Turbo.OneWayAdmin.Service.msgLoadingRequest', 'Loading service requests', null);

    //    this.Api.get<RequestDetails[]>('/Service/GetClaimRequests', { oneway: false }).then(x => {
    //        this.requests = x;

    //        this.sorters = this.ctrlSorters.toArray();
    //        this.pagers = this.ctrlPagers.toArray();

    //        this.populateDatasources();

    //        if (this.Settings.isInAny(['OneWayAdmin'])) {
    //            this.sorters[0].sort({ id: "CreatedAt", start: "asc", disableClear: false });
    //            this.sorters[1].sort({ id: "New", start: "asc", disableClear: false });
    //            //this.sorters[2].sort({ id: "New2", start: "asc", disableClear: false });
    //        }
    //        else {
    //            this.sorters[0].sort({ id: "New3", start: "asc", disableClear: false });
    //        }

    //        this.UI.loaderCompleted(token);
    //    });
    //}

    //private populateDatasources() {

    //    var today: moment.Moment = moment();

    //    if (this.Settings.isInAny(['OneWayAdmin'])) {
    //        this.newRequests = new T4DataSource(this.requests.slice().filter(x => x.Status! < ServiceRequestStatus.Received || (x.Status! >= ServiceRequestStatus.Received && x.Status! < ServiceRequestStatus.Completed && x.ExpectedResolveDate && x.ExpectedResolveDate >= today)), this.sorters[0], this.pagers[0], "New requests", this.assembleSearchString);
    //        this.featuredRequests = new T4DataSource(this.requests.slice().filter(x => x.Status! >= ServiceRequestStatus.Received && x.Status! < ServiceRequestStatus.Completed && (!x.ExpectedResolveDate || x.ExpectedResolveDate < today)), this.sorters[1], this.pagers[1], "Featured requests", this.assembleSearchString);
    //        //this.completedRequests = new T4DataSource(this.requests.slice().filter(x => x.Status! == ServiceRequestStatus.Completed), this.sorters[2], this.pagers[2], "Featured requests", this.assembleSearchString);
    //    }
    //    else {
    //        this.activeRequests = new T4DataSource(this.requests.slice().filter(x => x.Status! < ServiceRequestStatus.Completed), this.sorters[0], this.pagers[0], "All requests", this.assembleSearchString);
    //    }
    //}

    //private updateRequest(id: string) {
    //    var token = this.UI.beginLoading('Turbo.OneWayAdmin.Service.msgLoadingRequest', 'Loading service requests', null);

    //    this.Api.get<RequestDetails>('/Service/GetRequest', { id: id }).then(x => {
    //        var item = this.requests.find(y => y.Id == x.Id);
    //        if (!item) return;

    //        this.requests.splice(this.requests.indexOf(item), 1);
    //        this.requests[this.requests.indexOf(item)] = x;
    //        this.requests.push(x);

    //        this.populateDatasources();

    //        // Set filter
    //        if (this.featuredRequests) this.featuredRequests.filter = this.txtFilter.value;
    //        if (this.newRequests) this.newRequests.filter = this.txtFilter.value;
    //        if (this.activeRequests) this.activeRequests.filter = this.txtFilter.value;
    //        if (this.expiredRequests) this.expiredRequests.filter = this.txtFilter.value;
    //        if (this.missingRequests) this.missingRequests.filter = this.txtFilter.value;

    //        this.UI.loaderCompleted(token);
    //    });
    //}

    public showDetails(id: string) {
        this.Dialog.open(T4_ServiceDialog, { data: { requestId: id } }).afterClosed().toPromise().then(async (x: any) => {
            await this.populateDatasources();
            this.applyFilter();
        });
    }

    public export(data: T4DataSource) {
        data.export();
    }

    private assembleSearchString(item: RequestDetails): string {
        var searchStr = item.RequestNo + "|" + (item as any).ClaimId;
        if (item.RentalObject) {
            if (item.RentalObject.RentalLocation) {
                searchStr += item.RentalObject.RentalLocation!.Name + "|";
                searchStr += item.RentalObject.RentalLocation!.LocationCode + "|";
            }
            searchStr += item.RentalObject.Title + "|";
            searchStr += item.RentalObject.Alias + "|";
            searchStr += item.Status + "|";
            searchStr += item.Description + "|";
        }
        if (item.Tags) {
            for (var i = 0; i < item.Tags.length; i++) {
                searchStr += "|" + item.Tags[i];
            }
        }
        if (item.ServiceLocation) searchStr += item.ServiceLocation!.Name;

        return searchStr;
    }

    public tabChange(event) {
    }

    public filter(event) {
        this.allTables().forEach(t => t.txtFilter.setValue(event));
    }
}
